import cx from 'clsx';
import styles from '../../primitives/button.module.css';

type Size = 'medium' | 'small';
type AnySize = Size | 'large' | 'xsmall';

function resolveSize(sizeProp: AnySize | undefined, variant: string, iconOnly: boolean): Size {
  if (variant === 'tertiary' && !iconOnly) return 'small';
  if (sizeProp === 'large' || sizeProp === undefined) return 'medium';
  if (sizeProp === 'xsmall') return 'small';
  return sizeProp;
}

export function resolveButtonVariantProps<TIcon>({
  variant: variantProp,
  iconOnly = false,
  iconLeft,
  iconRight,
  size: sizeProp,
}: {
  variant?: string;
  iconOnly?: boolean;
  iconLeft?: TIcon;
  iconRight?: TIcon;
  size?: AnySize;
}) {
  const variant = variantProp ?? (iconOnly ? 'tertiary' : 'primary');

  const effectiveVariant =
    iconOnly && variant !== 'secondary' && variant !== 'tertiary' ? 'tertiary' : variant;

  return {
    effectiveVariant,
    effectiveIconLeft: !iconOnly && effectiveVariant === 'tertiary' ? iconLeft : undefined,
    effectiveIconRight: !iconOnly && effectiveVariant === 'tertiary' ? iconRight : undefined,
    effectiveSize: resolveSize(sizeProp, effectiveVariant, iconOnly),
  };
}

/**
 * Returns the full set of CSS class names for a button-styled element.
 * Shared by Button, InternalLink, and ExternalLink.
 */
export function getButtonClassNames({
  variant,
  size,
  iconOnly,
  stretch,
  className,
}: {
  variant: string;
  size: Size;
  iconOnly?: boolean;
  stretch?: boolean;
  className?: string;
}): string {
  return cx(
    'body-standard',
    styles.btn,
    variant !== 'primary' && styles[`btn--${variant}`],
    size !== 'medium' && styles[`btn--${size}`],
    iconOnly && styles['btn--icon-only'],
    iconOnly && variant === 'primary' && styles['btn--icon-only-primary'],
    stretch && styles['btn--stretch'],
    className
  );
}

export { styles as buttonStyles };
